import _Toast from "@kibt/meta-ui/es/toast";
import _regeneratorRuntime from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/node_modules/@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { defineStore } from 'pinia';
import { pick } from 'lodash-es';
import { watch } from '@vue/composition-api';
import yoda from '@ks/yoda-js-sdk';
import { appointment, getVenueData, receiveAward } from './services';
import { blackConfigMap } from './constants';
import { creatorStorage } from '@/utils/storage';
import { isInApp, useBridge } from '@/utils/yoda';
import { sendBlackMonthCustomLog } from '@/utils/custom-log';
import { scrollToTop } from '@/utils/dom';
import { logger } from '@/utils/logger';
export default defineStore('black-store', {
  state: function state() {
    return {
      data: null,
      loading: false,
      // 浏览的map
      browesedMap: {},
      // 预约的map
      appointmentStatusMap: {},
      userFollowingMap: {},
      currentAwardStatus: null,
      activeVenueIndex: 0,
      postPopupVisible: false,
      giftPopupVisible: false,
      // 记录是否点进发布了
      postInMap: {},
      // 当前最近场次开放的场馆，比如a,b,c
      recentlyOpenedVenue: null,
      // 当前最近点击查看用户P页的那个用户id
      recentlyClickUserId: null,
      currentPlayedPhotoIdStr: '',
      isScreening: false
    };
  },
  getters: {
    popupVisible: function popupVisible(state) {
      return state.postPopupVisible || state.giftPopupVisible;
    },
    // 简单错误处理,
    filteredVenues: function filteredVenues(state) {
      var _this = this;

      if (state.data && state.data.venues) {
        return state.data.venues.filter(function (item) {
          return !!blackConfigMap[item.venueId];
        }).map(function (item) {
          var _item$feeds;

          var currentAppointStatus = item.appointmentStatus;

          if (state.appointmentStatusMap[item.venueId] !== undefined) {
            currentAppointStatus = state.appointmentStatusMap[item.venueId];
          }

          return _objectSpread(_objectSpread({}, item), {}, {
            appointmentStatus: currentAppointStatus,
            // 内部存储了关注状态
            feeds: ((_item$feeds = item.feeds) === null || _item$feeds === void 0 ? void 0 : _item$feeds.filter(Boolean).map(function (feed) {
              // 注意，返回的是0｜1，因为之前定义的是boolean，再改就乱了
              var realFollowing = !!feed.following;

              if (_this.userFollowingMap[feed.user_id] === true || _this.userFollowingMap[feed.user_id] === false) {
                realFollowing = _this.userFollowingMap[feed.user_id];
              }

              return _objectSpread(_objectSpread({}, feed), {}, {
                following: realFollowing
              });
            })) || []
          });
        });
      }

      return [];
    },
    progressList: function progressList() {
      var _this2 = this;

      return this.filteredVenues.map(function (venue) {
        var curblackConfigValue = blackConfigMap[venue.venueId];
        return _objectSpread(_objectSpread(_objectSpread({}, venue), pick(curblackConfigValue, 'mainBackground', 'progressImg', 'progressTitle')), {}, {
          browesed: !!_this2.browesedMap[venue.venueId]
        });
      });
    },
    // 是否所有场馆都浏览过
    allBrowesed: function allBrowesed() {
      return this.progressList.every(function (item) {
        return item.browesed;
      });
    },
    // 这个是最终的是否领取奖励的状态
    computedAwardStatus: function computedAwardStatus(state) {
      if (state.data) {
        return state.currentAwardStatus !== null ? this.currentAwardStatus : state.data.awardStatus;
      }

      return 0;
    },
    activeVenue: function activeVenue() {
      if (this.filteredVenues[this.activeVenueIndex]) {
        var currentConfigValue = blackConfigMap[this.filteredVenues[this.activeVenueIndex].venueId];
        return _objectSpread(_objectSpread({}, this.filteredVenues[this.activeVenueIndex]), currentConfigValue);
      }

      return null;
    },
    postVenue: function postVenue() {
      if (this.postPopupVisible) {
        return this.recentlyOpenedVenue;
      }

      return this.activeVenue;
    },
    // 当前场馆是否开放
    activeVenueOpen: function activeVenueOpen() {
      var nowTime = new Date().getTime();

      if (this.activeVenue) {
        return this.activeVenue.openTime < nowTime;
      }

      return false;
    },
    activePostOptions: function activePostOptions() {
      return {};
    },
    mainList: function mainList() {
      return this.filteredVenues.map(function (item) {
        var curblackConfigValue = blackConfigMap[item.venueId];
        return _objectSpread(_objectSpread({}, item), pick(curblackConfigValue, 'mainBackground', 'mainImg', 'mainTitleImg', 'mainDesc'));
      });
    }
  },
  actions: {
    initSendLogger: function initSendLogger() {
      var _this3 = this;

      watch(function () {
        return _this3.activeVenue;
      }, function (newVal, oldVal) {
        if (newVal && newVal.venueId !== (oldVal === null || oldVal === void 0 ? void 0 : oldVal.venueId)) {
          logger.kwailog.sendShow({
            action: 'VENUE',
            params: {
              tab: newVal.venueId
            }
          });
        }
      }, {
        immediate: true
      });
    },
    initListen: function initListen() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (isInApp) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                _context.next = 4;
                return yoda.ready();

              case 4:
                // 监听发布事件
                yoda.event.addEventListener('ShareEvent', function (e) {
                  if (_this4.activeVenue) {
                    _this4.setPostIn(_this4.activeVenue.venueId);
                  }

                  _this4.changePostPopupVisible(false);
                });

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    // 初始化变量以及初始化存储逻辑
    initStorge: function initStorge() {
      var _this5 = this;

      var storage = creatorStorage.get('black_store');

      if (storage) {
        this.appointmentStatusMap = storage.appointmentStatusMap || {};
        this.browesedMap = storage.browesedMap || {};
        this.postInMap = storage.postInMap || {};
        this.currentAwardStatus = storage.currentAwardStatus || 0;
      }

      watch(function () {
        return [_this5.appointmentStatusMap, _this5.browesedMap, _this5.postInMap, _this5.currentAwardStatus];
      }, function () {
        creatorStorage.set('black_store', {
          appointmentStatusMap: _this5.appointmentStatusMap,
          browesedMap: _this5.browesedMap,
          postInMap: _this5.postInMap,
          currentAwardStatus: _this5.currentAwardStatus
        });
      }, {
        deep: true
      });
    },
    // 场景是用户点击头像进p页进行关注，又返回
    initResume: function initResume() {
      var _this6 = this;

      if (!isInApp) {
        return;
      } // 获取最新的关注状态


      yoda.event.addEventListener('resume', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var namespace, canuseRes, res;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this6.recentlyClickUserId) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                _context2.next = 4;
                return yoda.ready();

              case 4:
                namespace = 'business'; // 老版本兼容

                _context2.next = 7;
                return yoda.tool.canIUse({
                  namespace: namespace,
                  name: 'reqeustFollowStatus'
                });

              case 7:
                canuseRes = _context2.sent;

                if (!canuseRes.canUse) {
                  namespace = 'bussiness';
                }

                _context2.next = 11;
                return useBridge(namespace, 'reqeustFollowStatus', {
                  userIdToQuery: _this6.recentlyClickUserId.toString()
                });

              case 11:
                res = _context2.sent;

                if (res.result === 1) {
                  // 1-关注，2-未关注
                  _this6.changeFollowingMap(_this6.recentlyClickUserId, res.followStatus === 1);
                }

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      })));
    },
    initActiveVenueIndex: function initActiveVenueIndex() {
      var currentTime = new Date().getTime(); // 获取的是最近未开放的场馆的index，所以最近开放

      var index = this.filteredVenues.findIndex(function (item) {
        return item.openTime > currentTime;
      });
      if (this.filteredVenues[this.filteredVenues.length - 1].openTime <= currentTime) index = 4;
      this.activeVenueIndex = Math.max(0, index - 1);
      var currFilterVenue = this.filteredVenues[this.activeVenueIndex];

      if (currFilterVenue) {
        this.recentlyOpenedVenue = _objectSpread(_objectSpread({}, currFilterVenue), blackConfigMap[currFilterVenue.venueId]);
      }
    },
    initData: function initData() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var ret;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this7.loading = true;
                _context3.next = 3;
                return getVenueData();

              case 3:
                ret = _context3.sent;
                _this7.loading = false;

                if (ret.result === 1 && ret.data) {
                  // user给个默认的
                  _this7.data = ret.data;

                  if (!_this7.data.user) {
                    _this7.data = _objectSpread(_objectSpread({}, _this7.data), {}, {
                      user: {
                        avatar_url: '',
                        user_id: 0,
                        user_name: ''
                      }
                    });
                  }

                  _this7.initActiveVenueIndex();

                  _this7.initStorge();

                  _this7.initResume();

                  _this7.initListen();

                  _this7.initSendLogger();
                }

                return _context3.abrupt("return", ret);

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    changePostPopupVisible: function changePostPopupVisible(val) {
      this.postPopupVisible = val;
    },
    changeGiftPopupVisible: function changeGiftPopupVisible(val) {
      this.giftPopupVisible = val;
    },
    changeActiveVenueIndexById: function changeActiveVenueIndexById(id) {
      var index = this.filteredVenues.findIndex(function (item) {
        return item.venueId === id;
      });

      if (index === -1) {
        return;
      }

      this.changeActiveVenueIndex(index);
    },
    changeActiveVenueIndex: function changeActiveVenueIndex(val) {
      // 没关闭的弹窗，先关闭
      if (this.giftPopupVisible) {
        this.changeGiftPopupVisible(false);
        return;
      }

      if (this.postPopupVisible) {
        this.changePostPopupVisible(false);
        return;
      }

      this.activeVenueIndex = val;
      scrollToTop(); // // 改的时候，触发下这个
      // this.changePostPopupVisible(false);
    },
    changeFollowingMap: function changeFollowingMap(currentUserId, currentFollowing) {
      this.userFollowingMap = _objectSpread(_objectSpread({}, this.userFollowingMap), {}, _defineProperty({}, currentUserId, currentFollowing));
    },
    // type:0取消预约，1代表预约,-- 0无了，只有1了
    toAppointment: function toAppointment(venueId) {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var ret;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(_this8.data && _this8.data.user)) {
                  _context4.next = 6;
                  break;
                }

                _context4.next = 3;
                return appointment(_this8.data.user.user_id, venueId);

              case 3:
                ret = _context4.sent;

                if (ret.result === 1) {
                  _this8.appointmentStatusMap = _objectSpread(_objectSpread({}, _this8.appointmentStatusMap), {}, _defineProperty({}, venueId, true));
                }

                if (ret.result === 1) {
                  _Toast.show({
                    // type === 0
                    // ? 'Agenda cancelada' // 已取消成功
                    // : 
                    text: 'Agendou com sucesso'
                  });
                } else {
                  // 服务异常，请重试
                  _Toast.show({
                    text: 'Erro de servidor. Por favor, tente novamente'
                  });
                }

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    toReceiveAward: function toReceiveAward() {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var ret;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!(_this9.data && _this9.data.user)) {
                  _context5.next = 9;
                  break;
                }

                if (_this9.allBrowesed) {
                  _context5.next = 4;
                  break;
                }

                _Toast.show({
                  text: 'Continua sua visita!'
                });

                return _context5.abrupt("return");

              case 4:
                _context5.next = 6;
                return receiveAward(_this9.data.user.user_id);

              case 6:
                ret = _context5.sent;

                if (ret.result === 1) {
                  _this9.currentAwardStatus = 1;
                }

                if (ret.result === 1) {
                  setTimeout(function () {
                    _this9.changeGiftPopupVisible(false);
                  }, 2000);
                } else {
                  _Toast.show({
                    text: 'Erro de rede'
                  });
                }

              case 9:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    // 浏览过
    setBrowesed: function setBrowesed(venueId) {
      var _this10 = this;

      if (this.browesedMap[venueId]) {
        return;
      }

      this.browesedMap = _objectSpread(_objectSpread({}, this.browesedMap), {}, _defineProperty({}, venueId, true));

      if (this.allBrowesed) {
        _Toast.show({
          text: 'Parabéns, acabou de visitar todas as 4 exposições!'
        });

        setTimeout(function () {
          _this10.changeGiftPopupVisible(true);
        }, 1000);
      } else {
        _Toast.show({
          // 打卡成功
          text: 'Visita Registrada'
        });
      }
    },
    setPostIn: function setPostIn(venueId) {
      if (this.postInMap[venueId]) {
        return;
      }

      this.postInMap = _objectSpread(_objectSpread({}, this.postInMap), {}, _defineProperty({}, venueId, true));
    },
    setCurrentPlayedPhotoIdStr: function setCurrentPlayedPhotoIdStr(photoIdStr) {
      this.currentPlayedPhotoIdStr = photoIdStr || '';
    },
    setRecentlyClickUserId: function setRecentlyClickUserId(id) {
      this.recentlyClickUserId = id;
    },
    // 自定义埋点
    sendBlackCustomLog: function sendBlackCustomLog(event) {
      if (this.activeVenue) {
        sendBlackMonthCustomLog({
          event: event,
          src: this.activeVenue.venueId
        });
      }
    },
    sendClickLog: function sendClickLog(action) {
      if (this.activeVenue) {
        logger.kwailog.sendClick({
          action: action,
          params: {
            tab: this.activeVenue.venueId
          }
        });
      }
    },
    changeIsSreening: function changeIsSreening(val) {
      this.isScreening = val;
    }
  }
});